import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import styled from "@emotion/styled";
import { Box, Grid, Paper } from "@mui/material";
import Microsoft from "@mui/icons-material/Microsoft";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import Loading from "../components/loading";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

const SignIn = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const { instance } = useMsal();

  const handleSignIn = () => {
    setLoading(true);

    instance.loginRedirect({
      scopes: ["user.read"],
    });
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      {loading && <Loading open={loading} />}
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box
            component="div"
            sx={{
              width: "80%",
              mt: 20,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Item>
                  <Button onClick={handleSignIn} startIcon={<Microsoft />}>
                    Sign in with Azure AD
                  </Button>
                </Item>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default SignIn;
